module.exports = __webpack_public_path__ + "static/media/head_shadow.0226443a.svg";